import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Provenance from './pages/Provenance';
import ScanQR from './pages/ScanQR';
import './index.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/provenance" element={<Provenance />} />
          <Route path="/scan" element={<ScanQR />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
